import React from 'react';
import { ResponsiveSunburst } from '@nivo/sunburst';
import Wrapper from './style';
import theme, { colorScheme as scheme } from '../../configs/nivo';
import dataExample from './data.example';
import { toCurrency } from '../../utils/commonUtils';

const Index = (props) => {
  const { dataSource = dataExample, chartProps, colorScheme } = props;
  const CenteredMetric = ({ centerX, centerY }) => {
    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        className="font-paragraph_medium black1"
      >
        {chartProps?.metricName || 'Metrics'}
      </text>
    );
  };
  return (
    <Wrapper>
      <div className="component_sunburst_canvas">
        <ResponsiveSunburst
          data={dataSource}
          theme={theme}
          margin={{ top: 24, right: 12, bottom: 24, left: 12 }}
          id="name"
          value="value"
          borderWidth={2}
          colors={colorScheme || { scheme: scheme.default }}
          childColor={{ from: 'color', modifiers: [['brighter', 0.15]] }}
          enableArcLabels={false}
          valueFormat
          // arcLabelsSkipAngle={10}
          // arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 1.4]] }}
          layers={['arcs', 'arcLabels', CenteredMetric]}
          tooltip={(d) => {
            const { id, value, color } = d;
            return (
              <div
                style={{
                  padding: 4,
                  background: 'white',
                  border: '1px solid #EDF4F7',
                  boxSizing: 'border-box',
                  boxShadow: '0px 2px 4px -4px rgba(23, 30, 41, 0.1)',
                  bordeRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 12,
                }}
              >
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: color,
                    marginRight: 4,
                  }}
                />
                <div>
                  <div className="black1" style={{ fontWeight: 600 }}>
                    {id}
                  </div>
                  <div className="black1">
                    {chartProps.currency
                      ? toCurrency(value, chartProps.currency)
                      : value}
                  </div>
                </div>
              </div>
            );
          }}
        />
      </div>
    </Wrapper>
  );
};

export default Index;
